import { useEffect } from 'react';
import useAutoplay from 'src/hooks/useAutoplay';
import { TIME_INTERVAL } from './constants';

const useAutoplayOverlay = () => {
  const { goToNextVideo } = useAutoplay();

  useEffect(() => {
    const timeout = setTimeout(goToNextVideo, TIME_INTERVAL);

    return () => {
      clearTimeout(timeout);
    };
  }, [goToNextVideo]);
};

export default useAutoplayOverlay;
